import React, { Component } from 'react';
import { ActionType } from './OnlineEnums';

export class OnlineOtherSidePlayerView extends Component {

  constructor(props) {
      super(props);

      this.state = { selectedWordCount: 1, selectedWord: "" };
    }

    getStateText() {
        switch (this.props.nextAction) {
            case ActionType.GiveHint:
            case ActionType.FirstHint:
                return "Considering a hint";
            case ActionType.Guess: return "Considering a guess";
            case ActionType.ConfirmGuess: return "Confirming guess";
            default: return "";
        }
    }

    getMeOrThemText() {
        return "Other player's status";
    }

    getRegularContent() {
        return (
            <div className="otherPlayerView">
                <h4>Hints by other player</h4>
                <ul>
                    {this.props.givenHints.map((h, i) => <li key={"otherhint"+i }>{h.number} - {h.word}</li>)}
                </ul>
            </div>);
    }

    render() {
        return (
            <div>
                {this.getRegularContent()}
            </div>
        );
    }
}
